export default function inspectName(name) {
  var n = document.createElement("span");
  n.className = "observablehq--cellname";
  n.textContent = "".concat(name, " = ");
  return n;
}